import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  StudioVideo,
  StudioImage,
  deselectMedia,
  StudioService,
  StudioVideoShapeDescriptor,
  StudioScene,
  selectCurrentStudioScene,
  saveScene,
} from '../../element-editor/store/studio';
import { VideoTimeRange } from '../video-preview/video-preview.component';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'nw-media-preview-modal',
  templateUrl: './media-preview-modal.component.html',
  styleUrls: ['./media-preview-modal.component.scss'],
})
export class MediaPreviewModalComponent implements OnInit, OnDestroy {
  @Input()
  imageId: string;
  @Input() videoShape: StudioVideoShapeDescriptor | null = null;
  @Output() close = new EventEmitter<void>();

  @Output()
  saved = new EventEmitter<void>();

  @Output()
  videoSaved = new EventEmitter<StudioVideoShapeDescriptor>();

  range: VideoTimeRange = { from: 0, to: 0 };

  get videoPreview() {
    return this.video;
  }

  get media() {
    return this.video || this.image;
  }

  get isVideo(): boolean {
    return this.videoShape !== null;
  }

  get isImage(): boolean {
    return false;
  }

  get video(): StudioVideo | null {
    return this.videoShape
      ? this.studioService.videos[this.videoShape.videoId]
      : null;
  }

  get image(): StudioImage | null {
    return null;
  }

  currentScene: StudioScene | null = null;

  destroy$ = new Subject<void>();
  constructor(
    private store: Store,
    private studioService: StudioService,
  ) {
    this.store
      .select(selectCurrentStudioScene)
      .pipe(takeUntil(this.destroy$))
      .subscribe(scene => {
        this.currentScene = cloneDeep(scene);
      });
  }

  onTimeRangeChange(ranges: VideoTimeRange[]) {
    this.videoShape.clips = ranges;
    this.currentScene.shapes[this.videoShape.id] = {
      ...this.currentScene.shapes[this.videoShape.id],
      clips: ranges,
    };
    this.store.dispatch(saveScene({ value: this.currentScene }));
  }

  onClose() {
    this.close.emit();
    this.store.dispatch(deselectMedia());
  }

  onDone() {
    this.videoSaved.emit(this.videoShape);
  }

  ngOnInit(): void {}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
